<template>
  <!-- 抽奖 -->
  <broadcast v-if="isLottery" />
  <!-- 正常红包 -->
  <award-notice v-else />
</template>

<script>
import Broadcast from './Broadcast.vue'
import AwardNotice from '../AwardNotice.vue'

export default {
  name: 'AwardNoticeWrapper',
  components: { Broadcast, AwardNotice },
  data() {
    return {

    }
  },

  computed:{
    isLottery(){
      return this.$bus.lottery?.enableLottery
    }
  }
}
</script>

<style scoped>

</style>